import { RatingIcon, RatingFilledIcon } from 'cokitchen-icons';
import { RateType } from 'models/review.model';
import React from 'react';
import './styles.scss';

type Props = {
  rating: RateType;
  totalRatings: number;
};
const BrandRating = ({ rating, totalRatings }: Props) => {
  const { rate } = rating;
  const rateValue = parseFloat(rate);
  const percentage = (Number(rating.total_review) / totalRatings) * 100 || 0;

  return (
    <div className='flex gap-3 items-center mb-1 brand-rating'>
      <div className='flex gap-1 items-center'>
        {[1, 2, 3, 4, 5].map((i) => {
          return rateValue >= i ? (
            <RatingFilledIcon key={i} className='text-[#F9C320]' />
          ) : (
            <RatingIcon key={i} className='text-[#F9C320]' />
          );
        })}
      </div>
      <div className='w-4'>
        <p className='text-[#858585] text-xs'>{rating.total_review}</p>
      </div>

      <input
        type='range'
        className={`accent-[#E60A2B] disabled w-[179px] h-[7.16px] bg-[#F0F0F0]`}
        min='0'
        max={totalRatings > 0 ? totalRatings : undefined}
        value={percentage}
        style={{
          backgroundSize: `${percentage}% 100%`
        }}
        readOnly
      />
    </div>
  );
};

export default BrandRating;
